var _excluded = ["as"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
var FocusableContext = /*#__PURE__*/React.createContext(true);
var useFocusable = function useFocusable() {
  // Allow code to work in environments that havent upgraded react
  // This is neccessary because this code will be used in pagelets (via buttons)
  if (React.useContext) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return React.useContext(FocusableContext);
  }
  return true;
};
/**
 * Render a `FocusBoundary` that allows control over child focusable elements.
 *
 * Focusable children will allow focus if all parent `FocusBoundary`'s are enabled
 */
var FocusBoundary = function FocusBoundary(_ref) {
  var enabled = _ref.enabled,
    detached = _ref.detached,
    children = _ref.children;
  var parentIsFocusable = useFocusable();
  var isEnabled = enabled && (detached || parentIsFocusable);
  return /*#__PURE__*/React.createElement(FocusableContext.Provider, {
    value: isEnabled
  }, children);
};
process.env.NODE_ENV !== "production" ? FocusBoundary.propTypes = {
  /**
   * Children.
   */
  children: PropTypes.node.isRequired,
  /**
   * Ignore any parent `FocusBoundary`. This is useful when the component tree does
   * not represent the HTML tree (For example, when using React portals).
   */
  detached: PropTypes.bool,
  /**
   * Whether or not its children should be focusable
   */
  enabled: PropTypes.bool
} : void 0;
/**
 * Render an element that can receive focus.
 *
 * If this element has a `FocusBoundary` as a parent, the `FocusBoundary` will have
 * partial control over the `tabIndex` of the underlying `Focusable` element. If the `FocusBoundary`
 * is `enabled`, it will not affect the rendering of the underlying element; otherwise,
 * `tabIndex="-1"` will be passed to the underlying element.
 */
var Focusable = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var ComponentToRender = _ref2.as,
    props = _objectWithoutProperties(_ref2, _excluded);
  var focusProps = useFocusable() ? {} : {
    tabIndex: '-1'
  };
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: ref
  }, props, focusProps));
});
Focusable.displayName = 'Focusable';
process.env.NODE_ENV !== "production" ? Focusable.propTypes = {
  /**
   * Underlying element type to render
   */
  as: PropTypes.elementType
} : void 0;
export { FocusBoundary, Focusable };